import React from "react";
import { URLImgFront } from '../../../config/URLDB';
import ReCAPTCHA from "react-google-recaptcha";
import Loading from '../../Loading';
import Swal from 'sweetalert2';
import { ConsultarDatosClienteCampania, ListTiposIdentificacion_ } from '../../../services/WebAPI_Utrahuilca';

const validate = values => {
    const errors = {}
    if (values.tipoIden === 'DEFAULT') {
        errors.tipoIden = 'campo obligatorio'
    }
    if (!values.nit) {
        errors.nit = 'campo obligatorio'
    }
    if (!values.fecExpe) {
        errors.fecExpe = 'campo obligatorio'
    }
    return errors;
};

class ConsultaOverlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null,
            errors: {},
            overlay: false,
            tipoIden: 'DEFAULT',
            nit: '',
            fecExpe: '',
            stateLoading: false,
            nombreAso: '',
            valor: 'none',
            estadoSolicitud: true,
            activeBtnConsulta: null,
            infoPtosAsignados: [],
            tiposid: [],
        };

        this.recaptchaRef = React.createRef();
        this.resultadoRef = React.createRef();
    }

    async componentDidMount() {
        await this.CargarTipoIdentificacion();
    }

    CargarTipoIdentificacion = async () => {
        const datos = { tran: 7, idtipodoc: 0, abreviatura: 'N/A', desctipodoc: 'N/A', abrevutraweb: 'N/A', idtipopers: 0, estado: 1 };
        try {
            const registros = await ListTiposIdentificacion_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                let tiposid = [];
                for (const tipoid of registros) {
                    tiposid.push({ value: tipoid.idtipodoc, label: tipoid.desctipodoc, abrevutraweb: tipoid.abrevutraweb });
                }
                this.setState({
                    tiposid
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    textInput = (e) => {
        const { name, value } = e.target;
        if (name === "fecExpe") {
            //SE TOMA EXACTAMENTE EL AÑO
            const yearPart = value.split("-")[0];
            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }
        this.setState({ [name]: value });
    };

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    validRecat = () => {
        if (this.recaptchaRef.current.getValue()) {
            this.setState({
                estadoSolicitud: false
            })
        } else {
            this.setState({
                estadoSolicitud: true
            })
        }
    }

    ConsultarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });

        //SE VALIDA SI HAY CAMPOS INCOMPLETOS
        if (Object.keys(result).length > 0) {
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            return;
        }

        if (!Object.keys(result).length) {
            this.setState({
                stateLoading: true
            });

            const data = {
                tran: 12,
                tipoiden: this.state.tipoIden,
                nit: this.state.nit,
                fec_exp: this.state.fecExpe,
                id_camp: 32
            }

            ConsultarDatosClienteCampania(data).then(async (response) => {
                try {
                    if (response.data.length > 0) {
                        if (response.data[0].codresp) {
                            this.setState({
                                ptosAsignados: 'DEFAULT',
                                fecSorteo: '',
                                infoPtosAsignados: [],
                                nombreAso: '',
                                valor: 'none',
                            });

                            if (this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }

                            Swal.fire({
                                icon: 'error',
                                title: response.data[0].desresp
                            });
                        }
                        else {
                            var fecha = new Date(response.data[0].fecsorteo);
                            this.setState({
                                valor: 'block',
                                nombreAso: response.data[0].nomcom,
                                fecSorteo: fecha.getDate() + "/" + (fecha.getMonth() + 1) + "/" + fecha.getFullYear(),
                                infoPtosAsignados: response.data,
                                estadoSolicitud: true,
                                puntos: response.data[0].puntos
                            }, () => {
                                if (this.state.valor === 'block' && this.resultadoRef.current) {
                                    this.resultadoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            });

                            this.props.onInfoConsulta(response.data[0].id_cliente, response.data[0].puntos, response.data[0].nomcom, response.data[0].nit, response.data[0].correo, response.data[0].telcel, response.data[0].tipoiden);
                        }
                    }
                }
                catch (error) {
                    this.setState({
                        tipoIden: 'DEFAULT',
                        nit: '',
                        fecExpe: '',
                        ptosAsignados: 'DEFAULT',
                        fecSorteo: '',
                        infoPtosAsignados: [],
                        nombreAso: '',
                        valor: 'none',
                        estadoSolicitud: true,
                    });

                    if (this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }

                    Swal.fire({
                        icon: 'error',
                        text: 'Ocurrió un error!'
                    });
                }
            });
            this.setState({
                stateLoading: false,
            });
        }
    }

    render() {
        const { tipoIden, nit, fecExpe, nombreAso, errors, valor, activeBtnConsulta, activeButton } = this.state;
        return (
            <React.Fragment>
                <div className="planestimulos-formulario">
                    <div data-aos="zoom-out" className="overlay-container" style={(valor !== 'none' ? ({ display: "flex", maxHeight: "600px", alignItems: "center", maxHeight: "100%" }) : { maxHeight: "100%" })}>
                        <div className="row align-items-center">
                            <div className="col-12 text-center">
                                <p className="text-white" style={{ fontSize: 'clamp(16px, 4vw, 60px)', display: (valor === 'none' ? 'block' : 'none') }}>Consulta y <span className="d-inline font-weight-bold font-italic">redime</span> tus puntos</p>
                            </div>
                        </div>

                        <div className="row align-items-start pt-4">
                            <div className="col-12 px-2 px-sm-3 px-md-4">
                                <div style={{ display: (valor === 'none' ? 'block' : 'none') }}>
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Tipo de documento</h5>
                                        <select name="tipoIden" className="formControlCoopera" value={tipoIden} onChange={this.textInput}>
                                            <option value="DEFAULT" disabled>Selecciona...</option>
                                            {this.state.tiposid.map((e, i) => {
                                                return [
                                                    <option key={i} value={e.abrevutraweb}>{e.label}</option>
                                                ]
                                            })}
                                        </select>
                                        {errors.tipoIden && <strong className="text-danger small">{errors.tipoIden}</strong>}
                                    </div>
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Número de documento</h5>
                                        <input name="nit" type="text" className="formControlCoopera" value={nit} maxLength="20" onChange={this.textInput} />
                                        {errors.nit && <strong className="text-danger small">{errors.nit}</strong>}
                                    </div>
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Fecha expedición</h5>
                                        <input name="fecExpe" type="date" className="formControlCoopera" value={fecExpe} onChange={this.textInput} />
                                        {errors.fecExpe && <strong className="text-danger small">{errors.fecExpe}</strong>}
                                    </div>
                                    <div className="pt-3 d-flex justify-content-center">
                                        <form onSubmit={this.onSubmit} >
                                            <ReCAPTCHA ref={this.recaptchaRef} sitekey="6LfTTPgbAAAAAOKQp-b36jm-sJGpLIKw8cnZTzu-" onChange={this.validRecat} />
                                        </form>
                                    </div>
                                </div>
                                <div style={{ display: valor }} ref={this.resultadoRef}>
                                    <div className="row">
                                        <div className="col-12 datos-consulta">
                                            <div>
                                                <span className="text-white" style={{ fontSize: '40px', fontWeight: 'bold', textTransform: 'capitalize' }}> {nombreAso} </span>
                                            </div>
                                            <div>
                                                <span className="text-white" style={{ fontSize: '35px' }}> {this.state.nit} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2">
                                        <div className="col-12 d-flex align-items-center">
                                            <div className="flex-fill">
                                                <input type="text" value={this.state.puntos + " PUNTOS"} disabled className="text-center puntos-cooperaGanaMas"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center pt-3">
                                    <button id={"btnRegresar"} className="button-img border-0 bg-transparent" data-id={0} style={this.getActiveButton(activeButton === 0)} onClick={this.props.cerrarOverlay} >
                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_regresar.png`} alt="Anterior" style={{ width: '100%', height: '90px', touchAction: 'manipulation' }} />
                                    </button>

                                    <button className="button-img border-0 bg-transparent" id={"btnConsultar"} data-id={0} onClick={this.ConsultarDatos} disabled={this.state.estadoSolicitud} style={this.getActiveButton(activeBtnConsulta === 0), { display: (valor === 'none' ? 'block' : 'none') }} onTouchStart={() => this.setState({ activeBtnConsulta: 0 })}
                                        onTouchEnd={() => this.setState({ activeBtnConsulta: null })} onMouseDown={() => this.setState({ activeBtnConsulta: 0 })}
                                        onMouseUp={() => this.setState({ activeBtnConsulta: null })} onMouseLeave={() => this.setState({ activeBtnConsulta: null })}>
                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_consultar.png`} alt="Consultar" className="btn-consultar-Coopera" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        {this.state.stateLoading ? (
                            <Loading />
                        ) : (<React.Fragment></React.Fragment>)}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ConsultaOverlay;